import React from 'react';
import { Link } from 'react-router-dom';
import smpImg from '../assets/smp.webp';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SMPPage: React.FC = () => {
  return (
    <div className="App">
      <Header>
        <Link to="/#about">About</Link>
        <Link to="/#services">Services</Link>
        <Link to="/smp">SMP</Link>
        <Link to="/san-francisco">San Francisco</Link>
        <Link to="/san-jose">San Jose</Link>
      </Header>

      {/* SMP Hero Section */}
      <section className="smp-hero">
        <div className="container">
          <div className="smp-hero-content">
            <h1>Scalp Micro Pigmentation</h1>
            <p>The Ultimate Solution for Hair Loss</p>
          </div>
        </div>
      </section>

      {/* SMP Main Content */}
      <section className="smp-main">
        <div className="container">
          <div className="smp-content">
            <div className="smp-text">
              <h2>Revolutionary Hair Restoration</h2>
              <p>
                Scalp Micro Pigmentation (SMP) is a revolutionary non-surgical hair restoration treatment that creates the appearance of fuller, thicker hair. Using specialized micro-needles and pigments, we replicate the look of natural hair follicles directly on the scalp.
              </p>
              <p>
                Perfect for men experiencing male pattern baldness, thinning hair, or those who want to enhance their existing hairline. SMP provides immediate, long-lasting results with no downtime required.
              </p>
              <div className="smp-benefits">
                <h4>Benefits:</h4>
                <ul>
                  <li>✓ Immediate results</li>
                  <li>✓ Non-surgical procedure</li>
                  <li>✓ Natural-looking hairline</li>
                  <li>✓ Low maintenance</li>
                  <li>✓ Boosts confidence</li>
                  <li>✓ Cost-effective solution</li>
                </ul>
              </div>
              <div className="smp-pricing">
                <div className="price-tag">
                  <span className="price">Starting at $1,200</span>
                  <p>3-session package</p>
                </div>
              </div>
            </div>
            <div className="smp-image-section">
              <div className="smp-image" style={{ width: '100%', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 15px 40px rgba(0, 0, 0, 0.2)' }}>
                <div style={{ padding: '56.6% 0 0 0', position: 'relative', width: '100%' }}>
                  <iframe
                    src="https://player.vimeo.com/video/1094189551?h=40fd376ba8&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&loop=1&controls=0&title=0&byline=0&portrait=0&muted=1"
                    title="smp"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '20px' }}
                  ></iframe>
                </div>
                <div className="image-caption">
                  <p>Professional SMP results - Natural looking hairline restoration</p>
                </div>
              </div>
              <div className="smp-cta">
                <Link to="/#booking" className="btn btn-primary btn-large">Schedule Consultation</Link>
                <Link to="/#contact" className="btn btn-secondary">Learn More</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SMP Process Section */}
      <section className="smp-process">
        <div className="container">
          <h2>The SMP Process</h2>
          <div className="process-grid">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Consultation</h3>
              <p>We discuss your goals, examine your scalp, and design a personalized treatment plan.</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>First Session</h3>
              <p>We begin the pigmentation process, creating the foundation and initial hairline design.</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Second Session</h3>
              <p>We add density and refine the hairline, building upon the first session's foundation.</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Final Session</h3>
              <p>We perfect the treatment with final touches and ensure optimal density and color matching.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default SMPPage; 